<router-outlet></router-outlet>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/auth/auth.component.ts.AuthComponent.html